import { type AxiosRequestConfig } from 'axios'

const getUserEducationList = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: id ? `/users/${id}/info/education/list` : '/user/info/education/list'
  }
}

export { getUserEducationList }
